/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import _ from 'lodash';

import { SearchIcon } from '@coursera/cds-icons';

type Props = {
  onSearchChange: (search: string) => void;
  placeholder: string;
};

const styles = {
  input: () => css`
    border: 1px solid var(--cds-color-grey-600);
    border-radius: 4px;
    width: 100%;
    height: 48px;
    display: flex;
    padding: 12px;
    padding-left: 40px;

    &::placeholder,
    &::-webkit-input-placeholder {
      color: var(--cds-color-grey-600);
      opacity: 1;
    }
  `,
  icon: css`
    position: absolute;
    left: 10px;
    top: 14px;
  `,
  container: css`
    position: relative;
    width: 100%;
    margin-right: 8px;
    box-sizing: border-box;
  `,
};

const UsersListSearchBar = ({ onSearchChange, placeholder }: Props) => {
  const [searchText, setSearchText] = useState('');

  const setSearchChange = _.debounce((searchQuery: string) => {
    onSearchChange(searchQuery);
  }, 200);

  const handleSearchChange = (searchQuery: string) => {
    setSearchText(searchQuery);

    setSearchChange(searchQuery);
  };

  return (
    <div css={styles.container}>
      <div>
        <SearchIcon css={styles.icon} />
      </div>
      <input
        css={styles.input}
        value={searchText}
        placeholder={placeholder}
        aria-label={placeholder}
        type="text"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSearchChange(e.target.value)}
      />
    </div>
  );
};

export default UsersListSearchBar;
